// extracted by mini-css-extract-plugin
module.exports = {"root":"Consent_root__1c1Vc","content":"Consent_content__2wXJ5","footer":"Consent_footer__issua"};